module.exports = __webpack_public_path__ + "static/world-0e8852b2a29d9f16c3bef7ea74a1466a.png";